import React from 'react';
import '../css/TermsOfService.css';

const TermsOfService = () => {
  return (
    <div className="tos-container">
      <h1 classname="tos-title">Kullanım Sözleşmesi</h1>
      
      <section>
      <h3>1. Taraflar</h3>
      <p>
        Bu sözleşme, halısahacım.com ("Site") ile siteye kayıt olan kullanıcı ve işletmeler ("Kullanıcı") arasında akdedilmiştir.
      </p>
      </section>

      <section>
      <h3>2. Hizmet Tanımı</h3>
      <p>
        Site, halı saha işletmelerinin saha bilgilerini tanıtabilecekleri, kullanıcıların ise sahaları görüntüleyip rezervasyon talebinde bulunabilecekleri bir platformdur.
        Ödeme alma özelliği yalnızca site yönetimi tarafından işletmelere sunulan hizmetlerin karşılığı olarak kullanılır. Kullanıcılar veya işletmeler kendi aralarında ödeme işlemi yapamaz.
      </p>
      </section>

      <section>
      <h3>3. Üyelik</h3>
      <p>
        İşletme sahipleri ve kullanıcılar, platforma kayıt olarak bu sözleşme hükümlerini kabul etmiş sayılır. Kayıt sırasında verilen bilgilerin doğruluğu kullanıcı sorumluluğundadır.
      </p>
      </section>

      <section>
      <h3>4. Ücretlendirme</h3>
      <p>
        Siteye kayıt olmak ücretsizdir. Ancak işletmeler, tanıtım ve rezervasyon taleplerine erişim gibi hizmetler için belirli bir ücret ödemeyi kabul eder.
        İlk kullanım ayı ücretsizdir. Devam eden kullanım için ödeme yapılmadığı takdirde işletme profili devre dışı bırakılır.
      </p>
      </section>

      <section>
      <h3>5. Kullanım Koşulları</h3>
      <ul>
        <li>Kullanıcılar, yanlış, aldatıcı veya zararlı içerik yükleyemez.</li>
        <li>İşletme sahipleri, hizmet veremeyecekleri saatler için rezervasyon almamalıdır.</li>
        <li>Sistem kötüye kullanılırsa, üyelik askıya alınabilir veya kalıcı olarak sonlandırılabilir.</li>
      </ul>
      </section>

      <section>
      <h3>6. Sorumluluk Reddi</h3>
      <p>
        Site, kullanıcılar ve işletmeler arasında doğrudan gerçekleşen iletişimlerden veya anlaşmazlıklardan sorumlu değildir. Site yalnızca aracı platformdur.
      </p>
      </section>

      <section>
      <h3>7. Fikri Mülkiyet Hakları</h3>
      <p>
        Site içeriği (logo, tasarım, yazılım) halısahacım.com'a aittir. İzinsiz kopyalanamaz veya çoğaltılamaz.
      </p>
      </section>

      <section>
      <h3>8. Değişiklik Hakkı</h3>
      <p>
        halısahacım.com, bu sözleşmeyi gerektiğinde önceden haber vermeksizin değiştirme hakkını saklı tutar.
        Güncellenmiş sözleşme, yayım tarihi itibariyle geçerli olacaktır.
      </p>
      </section>

      <section>
      <h3>9. İletişim</h3>
      <p>
        Soru ve önerileriniz için <a href="mailto:halisahacim.com@gmail.com">halisahacim.com@gmail.com</a> adresine ulaşabilirsiniz.
      </p>
      </section>
    </div>
  );
};

export default TermsOfService;
